<template>
<div>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-8 text-center">
            <img v-if="$route.params.ta == 'ta'" class="u-pl2 u-pb2 u-pt2" src="https://www.teacheractive.com/wp-content/uploads/2014/04/logo_ta1.png"/>
            <img v-else class="u-pl2 u-pb2 u-pt2" src="https://shift-manager.mobilerocket.co.uk/storage/business-logos/rocket.png"/>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
            <div class="card">
                <div class="card-body">
                    <div class="col-12" v-if="page=='login'">
                        <h3>Login to view your forms</h3>
                        <form v-on:submit.prevent="checkLogin">
                            <div class="form-group">
                                <label for="email" class="col-form-label text-md-right">Email</label>
                                <input id="email" type="email" class="form-control" name="email" v-model="model.email" required autocomplete="email" autofocus>
                            </div>
                            <div class="form-group">
                                <label for="password" class="col-form-label text-md-right">Password</label>
                                <input id="password" type="password" class="form-control" name="password" v-model="model.password" required autocomplete="password" autofocus>
                            </div>
                            <div class="form-group u-mb1">
                                <button type="submit" class="btn btn-secondary">
                                    Login
                                </button>
                                <button type="submit" class="btn btn-link" v-on:click="page='reset'">
                                    Reset Password
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="col-12" v-else>
                        <h3>Reset your password</h3>
                        <form v-on:submit.prevent="resetPassword">
                            <div class="form-group">
                                <label for="email" class="col-form-label text-md-right">Email</label>
                                <input id="email" type="email" class="form-control" name="email" v-model="model.email" required autocomplete="email" autofocus>
                            </div>
                            <div class="form-group u-mb1">
                                <button type="submit" class="btn btn-secondary">
                                    Reset your password
                                </button>
                                <button type="submit" class="btn btn-link" v-on:click="page='login'">
                                    Login
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import {alerts} from '@/mixins/alerts.js';
export default {
    name : 'LoginForm',
    data () {
        return {
            model : {
                email : '',
                password : ''
            },
            page : 'login'
        }
    },
    mounted : function () {
        let self = this;
    },
    methods : {
        checkLogin () {
            // post, then set values
            this.axios.post(this.$root.env_url + '/api/auth/login', this.model)
                .then(response => {
                    console.log('logged in', response.data);
                    this.$root.login(response.data.access_token);
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not log you in. Was that the right password?');
                    console.error('could not log in', error);
                });
        },
        resetPassword () {
             // post, then set values
            this.axios.post(this.$root.env_url + '/api/auth/password', this.model)
                .then(response => {
                    console.log('logged in', response.data);
                    this.page = 'login';
                    this.successMsg('If you have an account we will send you a password reset link');
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not reset your password. Did you use the right email address?');
                    console.error('could not reset your password', error);
                });
        }
    }
}
</script>